import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { prefetchShowPricing } from "@/hooks/useShowPricing";

// The logged-out homepage is the landing page. Ask for its pricing switch
// now, alongside the first auth check, instead of after the page has mounted
// (see hooks/useShowPricing).
try {
  if (window.location.pathname === '/' && !localStorage.getItem('token')) prefetchShowPricing();
} catch {
  // Storage blocked — the landing page asks when it mounts.
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        console.log('SW registered:', reg.scope);
      })
      .catch((err) => {
        console.log('SW registration failed:', err);
      });
  });

  // The worker stores what it sees being fetched, and it saw none of this
  // page being loaded if it took over afterwards: on a first visit the page is
  // complete before the worker exists, and a worker with a new cache name
  // starts empty. Such a page could not be opened offline until it had been
  // loaded a second time. So when a worker takes this page over, tell it what
  // the page has loaded, and it stores what it is missing (the "message"
  // handler in public/sw.js).
  // Only files are listed, never calls the app made: the worker fetches each
  // URL again, and an API request or an analytics hit must not be repeated.
  const CALLS = ['fetch', 'xmlhttprequest', 'beacon'];
  let stillLoading = null;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    const takenOverAt = performance.now();
    const report = (entries) => {
      const urls = entries
        .filter((entry) => entry.startTime < takenOverAt && !CALLS.includes(entry.initiatorType))
        .map((entry) => entry.name);
      if (urls.length) {
        navigator.serviceWorker.controller?.postMessage({ type: 'STORE_LOADED_FILES', urls });
      }
    };
    report([...performance.getEntriesByType('navigation'), ...performance.getEntriesByType('resource')]);
    // A file that was still on its way when the worker took over shows up later.
    stillLoading?.disconnect();
    stillLoading = new PerformanceObserver((list) => report(list.getEntries()));
    stillLoading.observe({ entryTypes: ['resource'] });
  });
}
